import React from 'react';

import { InputLabel } from '@mui/material';

const labelSx = {
  fontSize: '0.875rem',
  lineHeight: '1.5rem',
  marginBottom: 0,
  justifyContent: 'left',
  textAlign: 'left',
};

interface DetourLabelProps {
  lbl: string;
}

export function DetourLabel({ lbl }: DetourLabelProps) {
  const htmlFor = `detour-${lbl.toLowerCase().replace(/\s+/g, '-')}`;
  return (
    <InputLabel htmlFor={htmlFor} sx={labelSx}>
      {lbl}
    </InputLabel>
  );
}
